// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3p4Q6","content":"Consent_content__9fbj4","footer":"Consent_footer__1qqyo"};